/* tslint:disable */
/* eslint-disable */
/**
 * DocumentService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    InterrogatoryResponseItem,
    InterrogatoryResponseItemFromJSON,
    InterrogatoryResponseItemFromJSONTyped,
    InterrogatoryResponseItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface SupplementalInterrogatoryResponseDetails
 */
export interface SupplementalInterrogatoryResponseDetails {
    /**
     * 
     * @type {string}
     * @memberof SupplementalInterrogatoryResponseDetails
     */
    documentId?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplementalInterrogatoryResponseDetails
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SupplementalInterrogatoryResponseDetails
     */
    order?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SupplementalInterrogatoryResponseDetails
     */
    isParent?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SupplementalInterrogatoryResponseDetails
     */
    userFormattedResponse?: string | null;
    /**
     * 
     * @type {Array<InterrogatoryResponseItem>}
     * @memberof SupplementalInterrogatoryResponseDetails
     */
    interrogatoryResponseItems?: Array<InterrogatoryResponseItem> | null;
}

export function SupplementalInterrogatoryResponseDetailsFromJSON(json: any): SupplementalInterrogatoryResponseDetails {
    return SupplementalInterrogatoryResponseDetailsFromJSONTyped(json, false);
}

export function SupplementalInterrogatoryResponseDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplementalInterrogatoryResponseDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'documentId': !exists(json, 'documentId') ? undefined : json['documentId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'order': !exists(json, 'order') ? undefined : json['order'],
        'isParent': !exists(json, 'isParent') ? undefined : json['isParent'],
        'userFormattedResponse': !exists(json, 'userFormattedResponse') ? undefined : json['userFormattedResponse'],
        'interrogatoryResponseItems': !exists(json, 'interrogatoryResponseItems') ? undefined : (json['interrogatoryResponseItems'] === null ? null : (json['interrogatoryResponseItems'] as Array<any>).map(InterrogatoryResponseItemFromJSON)),
    };
}

export function SupplementalInterrogatoryResponseDetailsToJSON(value?: SupplementalInterrogatoryResponseDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'documentId': value.documentId,
        'name': value.name,
        'order': value.order,
        'isParent': value.isParent,
        'userFormattedResponse': value.userFormattedResponse,
        'interrogatoryResponseItems': value.interrogatoryResponseItems === undefined ? undefined : (value.interrogatoryResponseItems === null ? null : (value.interrogatoryResponseItems as Array<any>).map(InterrogatoryResponseItemToJSON)),
    };
}


